import VideoCallout from './VideoCallout';

export default VideoCallout;



// WEBPACK FOOTER //
// ./src/components/shared/VideoCallout/index.js